module.exports = __webpack_public_path__ + "static/media/blackArrow.55f91cd8.svg";